import { render, staticRenderFns } from "./size-guide.vue?vue&type=template&id=31324bcd&scoped=true"
import script from "./size-guide.vue?vue&type=script&lang=js"
export * from "./size-guide.vue?vue&type=script&lang=js"
import style0 from "./size-guide.vue?vue&type=style&index=0&id=31324bcd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31324bcd",
  null
  
)

export default component.exports